import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=adb431d6&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=adb431d6&lang=less&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&id=adb431d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb431d6",
  null
  
)

export default component.exports